import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';

function useTrackActivation() {
  const { mutate: trackActivation, isLoading: isTrackingActivation } = useMutation(
    ({ userAgent, eventType }: { userAgent: string; eventType: string }) =>
      BackendService.instance.marketing.trackActivation({
        userAgent,
        eventType,
      }),
  );

  return {
    trackActivation,
    isTrackingActivation,
  };
}

export default useTrackActivation;
